<template lang="pug">
  .carousels.srv-images.component
    carousel(
      :perPage='1'
      :paginationEnabled="false"
      :navigationEnabled='true'
    )
      slide.slide( v-for='img in imgs' :key='img.src' )
        img( :src='img.src' )
</template>

<script>
  import { Carousel, Slide } from 'vue-carousel'

  export default {
    name: 'carousels.srv-imgs.component',

    components: {
      Carousel,
      Slide
    },

    props: {
      imgs: { default: () => ({}) },
      srv: { required: true, default: () => ({}) }
    }
  }
</script>

<style lang="stylus" scoped>
  img
    display block
    width 100%
    border-radius 7px
    height 100%
    object-fit cover
</style>